import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
} from '@mui/material';

import './eulaPage.scss';

function EulaPage(props) {

    const { eulaAcceptPending } = props;

    function handleAcceptCallback() {
        props.history.push('/');
    }

    function handleClose() {
        const { actions: { sessionLogout } } = props;
        sessionLogout();
    }

    function handleAgree() {
        const { actions: { sessionAcceptEula } } = props;
        sessionAcceptEula(handleAcceptCallback);
    }

    return (
        <React.Fragment>
            <Dialog
                open={true}
                onClose={handleClose}
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id="scroll-dialog-title">PARTICIPATION AND END USER LICENSE AGREEMENT (EULA) {props.eulaVersion}</DialogTitle>
                <DialogContent dividers={true}>
                    <div className="MuiTypography-root MuiDialogContentText-root MuiTypography-body1 MuiTypography-colorTextSecondary"
                        dangerouslySetInnerHTML={{
                            __html: props.eulaContent
                        }}>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Disagree
                    </Button>
                    <Button disabled={eulaAcceptPending} onClick={handleAgree} color="primary" autoFocus>
                        {(eulaAcceptPending) ? 'Agree..' : 'Agree'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default EulaPage;